import React, { Component, PropTypes } from 'react';
import axios from 'axios';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';
import config from '../../../../config/config';

const appUrlPath = `/${config.appUrlPath}`;

class Make extends Component {

  constructor(props) {
    super(props);
    this.state = {
      option: [],
      isDataLoaded: false
    }
  }

  componentWillMount() {
    axios.get(`${appUrlPath}/getDistinctMake`, {
      params: {}
    })
    .then((res) => {
      this.setState({ option: res.data, isDataLoaded: true });
    })
    .catch(() => {
    });
  }

  render() {
    return (
      <FormGroup controlId="make">
        <Col componentClass={ControlLabel} sm={5}>
          Make *
        </Col>
        <Col sm={7}>
          {this.state.isDataLoaded ?
            <div className="ebaoUtil__Container">
              <select
               className="custom-select"
               value={this.props.make}
               onChange={this.props.handleChangeMake}
               id="make"
               required
             >
               <option value="">Please Select</option>
               {this.state.option.map((obj, index) => {
                 const counter = index
                 return (
                   <option
                     value={obj.make}
                     key={counter}
                   >{obj.make}</option>
                 );
               })}
             </select>
           </div> : <div>Loading</div>}
        </Col>
      </FormGroup>
    )
  }
}

Make.propTypes = {
  handleChangeMake: PropTypes.func,
  make: PropTypes.string
};

export default Make;



// WEBPACK FOOTER //
// ./src/app/components/coverNotePVComponent/make/Make.js